"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
/* https://www.figma.com/design/BY4kFsvfAjmHS7W8N4SiSf/NerdWallet%2B-Design-Toolkit?node-id=187-22739&t=FjsTYA77KSedsO39-4 */
exports.colors = {
    "blue-dark": "#02427E",
    "blue-extra-light": "#DEEFFF",
    "blue-lighter-2": "#C8E4FE",
    "blue-lightest": "#EEF7FF",
    "dark-logo-green-tint-1": "#267F4C",
    "dark-logo-green-tint-2": "#2A9859",
    green: "#008254",
    "green-dark": "#006642",
    "green-darkest": "#00482F",
    "green-extra-light": "#EFFCF8",
    "green-light": "#40AD87",
    "green-lighter": "#81D6B8",
    "green-lighter-2": "#B7ECDA",
    "green-lightest": "#E3FAF2",
    "green-tint-lp": "#A8EA4C",
    lime: "#E2FF39",
    "lime-tint-lp-1": "#DDFA88",
    "lime-tint-lp-2": "#E8FDAC",
    "lime-tint-lp-3": "#F8FFE4",
    "orange-nw-plus": "#F8991D",
    "starbust-red": "#FF6A4D",
    "thriver-blue": "#BCEBFF",
    "thriver-blue-tint-1": "#D7F3FF",
    "wavy-pink": "#FF97E9",
    "yellow-lighter": "#FFE2AE",
    "yellow-lighter-2": "#FFF0D6",
    "yellow-lightest": "#FFF7EA",
};
